import { createContext, useContext } from "react";
import { io } from "socket.io-client";
import AuthContext from "./AuthProvider";

const SocketContext = createContext({});

export const SocketProvider = ({ children }) => {
  const { auth } = useContext(AuthContext);

  const socketURL = process.env.NODE_ENV === "production" ? "https://wgsitetest.com" : "http://localhost:4001";
  // const socket = io.connect("http://localhost:8080", {
  const socket = io.connect(socketURL, {
    transports: ["websocket", "polling", "flashsocket"],
    auth: {
      token: `Bearer ${auth.accessToken}`,
    },
    // autoConnect: false,
  });

  return <SocketContext.Provider value={{ socket }}>{children}</SocketContext.Provider>;
};

export default SocketContext;
